// @flow

import { FIELD_ID } from '../invoice/invoice.const';

export const amountPattern = '^(([0-9]{1,7})(.|,){1}([0-9]{1,2})|([0-9]{1,3}))$';

export const SAVE_PAYMENTS_SETTINGS = 'SAVE_PAYMENTS_SETTINGS';

export const defaultPaymentsSettings = {
  applicationFee: 0
};

const NUMBER_ERROR_MESSAGE = 'Please enter a valid number';

export const errorMessages = {
  [FIELD_ID.RATE]: NUMBER_ERROR_MESSAGE,
  [FIELD_ID.QTY]: NUMBER_ERROR_MESSAGE,
  [FIELD_ID.DISCOUNT]: NUMBER_ERROR_MESSAGE,
  [FIELD_ID.DISCOUNT_PERCENTAGE]: NUMBER_ERROR_MESSAGE,
  [FIELD_ID.SALES_TAX]: NUMBER_ERROR_MESSAGE,
  [FIELD_ID.INVOICE_NUMBER]: 'Invoice number is required'
};
